import React, { useState } from "react";
import AddSectionModal from "./AddSectionModal";
import { getImageUrl } from "../../../commons/assets_path";
import { NoticeMessage } from "../flowbots/Notice/NoticeMessage";
import axios from "axios";
import { useTranslation } from "react-i18next";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

type Props = {
  clientCode: string;
};

const AddSectionButton = ({ clientCode }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notice, setNotice] = useState<{ isShow: boolean; message: string; type: string }>({
    isShow: false,
    message: "",
    type: "",
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const onSubmit = async (name: string): Promise<string> => {
    const res = await axios
      .post(`/${clientCode}/sections`, {
        name: name,
      })
      .catch((error) => {
        return error.response;
      });

    if (res.status === 200) {
      window.location.href = res.data.url;
      closeModal();
      return "";
    } else if (res.status === 422) {
      return res.data.errors.name[0];
    } else {
      return t("AddSectionButton.プロジェクトの作成に失敗しました");
    }
  };

  return (
    <>
      <div
        onClick={openModal}
        className="ml-auto"
        style={{ cursor: "pointer", padding: "4px" }}
        data-testid="add-section-button"
      >
        <img
          src={getImageUrl("images/icons/addPrimary.svg")}
          width="20"
          height="20"
          alt={t("AddSectionButton.セクション追加")}
        />
      </div>
      <AddSectionModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={onSubmit}
        isEdit={false}
        setNotice={setNotice}
      />
      <NoticeMessage notice={notice} setNotice={setNotice} />
    </>
  );
};

export default AddSectionButton;
